import { MainLayout } from "layouts";
import { TextInput } from "components/TextInput";
import { TextArea } from "components/TextArea";
import { UploadImage } from "components/UploadImage";
import { Button } from "components/Button";
import { Select } from "components/Select";
import { ThreeDotMenu } from "components/ThreeDotMenu";
import { RichRext } from "components/RichText";
import { Badge } from "components/Badge";

import { useRecipePage } from "./hooks";
import { menuItems } from "./helpers";

export const RecipePage = ({
  match: {
    params: { id },
  },
}: any) => {
  const {
    formData,
    categoryOptions,
    inputChanged,
    onFileChange,
    onFormSave,
    onSelectChange,
    onDeleteRecipe,
    onRichTextChange,
    onPublishClick,
  } = useRecipePage(id);

  const resolveTitle = () => {
    if (id < 0) return "Create recipe";
    return "Edit recipe";
  };

  return (
    <MainLayout
      title={resolveTitle()}
      badge={
        <Badge
          text={formData.published ? "Published" : "Unpublished"}
          color={formData.published ? "green" : "red"}
        />
      }
      rightElement={
        id > 0 ? (
          <ThreeDotMenu
            menuItems={menuItems(
              formData.published,
              onDeleteRecipe,
              onPublishClick
            )}
          />
        ) : undefined
      }
    >
      <form className="flex flex-col gap-3">
        <TextInput
          name="title"
          type="text"
          value={formData.title}
          onChage={inputChanged}
          label="Title"
        />
        <div className="form-row">
          <Select
            containerClassName="flex-1"
            label="Category"
            options={categoryOptions}
            selected={formData.category}
            onChange={onSelectChange}
          />
          <TextInput
            containerClassName="flex-1"
            name="slug"
            type="text"
            value={formData.slug}
            onChage={inputChanged}
            label="Slug"
          />
        </div>
        <div className="form-row">
          <TextInput
            containerClassName="flex-1"
            name="cookingTime"
            type="text"
            value={formData.cookingTime}
            onChage={inputChanged}
            label="Cooking time"
          />
          <TextInput
            containerClassName="flex-1"
            name="metaTitle"
            type="text"
            value={formData.metaTitle}
            onChage={inputChanged}
            label="Meta title"
          />
          <TextInput
            containerClassName="flex-1"
            name="numberOfPeople"
            type="number"
            value={formData.numberOfPeople}
            onChage={inputChanged}
            label="Number of people"
          />
        </div>
        <TextArea
          name="metaDescription"
          value={formData.metaDescription}
          onChage={inputChanged}
          rows={2}
          label="Meta description"
        />
        <RichRext
          label="Ingredients"
          value={formData.ingredients}
          onBlur={(newContent) => onRichTextChange(newContent, "ingredients")}
        />
        <RichRext
          label="Content"
          value={formData.content}
          onBlur={(newContent) => onRichTextChange(newContent, "content")}
        />
        <UploadImage
          label="Recipe image"
          imageUrl={formData.image?.url}
          onChange={onFileChange}
        />
        <Button label="Save" className="md:w-36" onClick={onFormSave} />
      </form>
    </MainLayout>
  );
};
